const DollarSign = ({
  className = 'dollar-sign-icon',
  fill = '#4CB919',
  height = 22,
  width = 22,
  title = 'Payment Page'
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    id='icn-payment'
    viewBox='0 0 36 36'
    className={className}
    role='img'
    aria-labelledby='payment-page-icon'
    height={height}
    width={width}
  >
    <title id='payment-page-icon'>{title}</title>
    <path
      fill={fill}
      d='M22.2,26.5a4.5,4.5,0,0,1-2.3,1.2l.6-7.3.7.3,1.1.7a3,3,0,0,1,.7,1,2.9,2.9,0,0,1,.3,1.3,4,4,0,0,1-1,2.9M16,14.1,15,13.4a3.3,3.3,0,0,1-.7-1,2.9,2.9,0,0,1-.3-1.3,3.3,3.3,0,0,1,.2-1.2,2.8,2.8,0,0,1,.7-1,4,4,0,0,1,1.2-.8l1.8-.4-.6,7.1L16,14.1m11.1,5.8a6.3,6.3,0,0,0-1.7-2,9.8,9.8,0,0,0-2.4-1.3l-2-.7L21.6,8a7.3,7.3,0,0,1,3.6,2.2h0l2.1-3.4L26,5.8h0L24.7,5a9.9,9.9,0,0,0-2.8-1L22.2.3,18.6,0l-.3,3.7a10.5,10.5,0,0,0-3.7.8,9.1,9.1,0,0,0-2.7,1.8,7.4,7.4,0,0,0-2.3,5.3,7.2,7.2,0,0,0,.6,3.2A6.3,6.3,0,0,0,11.9,17a8.9,8.9,0,0,0,2.4,1.4l2.7.9h0l-.7,8.5h0a6.6,6.6,0,0,1-1.9-.6L13,26.4l-2.4-1.5L8.4,28.2l1.2,1h0l.7.5,1.4.8a14.5,14.5,0,0,0,4.2,1.2h0l-.3,4,3.6.3.4-4.3a10.3,10.3,0,0,0,3-.8A9,9,0,0,0,25.4,29a8.1,8.1,0,0,0,1.7-2.7,9.3,9.3,0,0,0,.6-3.3,6.1,6.1,0,0,0-.7-3'
    />
  </svg>
);

export default DollarSign;
